var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-div"},[_c('span',{staticClass:"logo-title-name",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_vm._v(_vm._s("<" + _vm.name))]),_vm._v(" "),_c('span',{staticClass:"logo-title-name",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_vm._v(_vm._s(" />"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }